import { translate } from '@gig/magic-common';
import { ValidationDisplay, required, minLength, maxLength, notOnlyWhitespaces } from '@gig/magic-form-builder';

function address() {
    return {
        id: 'address',
        serverId: 'addrStreetAddress',
        component: 'magic-ui-form-field',
        isDataField: true,
        type: 'text',
        testId: 'step2-address',
        properties: {
            placeholder: translate('sign-up-step-two.address.placeholder'),
        },
        validationDisplay: ValidationDisplay.OnTouchShowMessage,
        validation: [
            {
                name: 'required',
                fn: required,
                message: translate('sign-up-step-two.address.required-error'),
            },
            {
                name: 'min-length',
                fn: minLength(2),
                message: translate('sign-up-step-two.address.min-length-error'),
            },
            {
                name: 'max-length',
                fn: maxLength(100),
                message: translate('sign-up-step-two.address.max-length-error'),
            },
            {
                name: 'not-only-whitespaces',
                fn: notOnlyWhitespaces,
                message: translate('sign-up-step-two.address.not-only-whitespaces-error'),
            },
        ],
    };
}

export { address };
